import { createBrowserHistory } from 'history';
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import 'semantic-ui-css/semantic.min.css';
import Root from './containers/Root';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './store/configureStore';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
}

const store = configureStore();
const history = createBrowserHistory();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root store={store} history={history} />);

registerServiceWorker();

if (module.hot) {
  module.hot.accept();
}
